import { SimpleInput } from '@aloft/toolkit-sui';

import { forwardRef } from 'react';

import { SimpleInputProps } from '../../../../../toolkit-sui/dist/components/SimpleInput/types';

type DateInputProps = Pick<
  SimpleInputProps,
  'onChange' | 'onBlur' | 'name' | 'label' | 'required' | 'errorMessage' | 'value'
>;

export const MonthDateInput = forwardRef<HTMLInputElement, DateInputProps>((props, ref) => {
  return <SimpleInput ref={ref} size="sm" type="month" {...props} />;
});
